import React, { useEffect, useRef, useState } from 'react'
import messageStyle from './messages.module.css'
import { TypeMessageIcon, MoreIcons, OnlineIcon, SearchIcon, SentIcon, PlusIcon, UnreadMessage, BackArrow, BackArrowIcon } from '../../svg';
import { CircularProgress } from '@mui/material';
import NewMessageModal from './NewMessageModal';
import { useDispatch, useSelector } from 'react-redux';
import { addClientMessage, addNewChatHistory, getAllActiveAdmins, getAllChats, getusersChat, setActiveUser, setMessages, setUsers, updateChatHistories, updateReadStatus } from '../redux/chat';
import { formatDateToHHMM, getRelativeTime } from '../helper/converter';
import { useWebSocket } from '../../context/socketContext'; // Import the WebSocket hook


const Messages = () => {
    const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openModal, setOpenModal] = React.useState(false);
    const { socket, isConnected, notifications, onlineUserIds } = useWebSocket();
    const { user } = useSelector(state => state.user)
    const userHistory = useSelector(state => state.chat)
    const activeUser = userHistory?.activeUser

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [content, setContent] = useState("")
    const activeUserRef = useRef({ userId: null, chatId: null })
    // const [activeUser, setActiveUser] = useState({
    //     userId: null,
    //     chatId: null
    // });
    const [chats, setChats] = useState([])
    const [chatFetched, setChatFetched] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const flatListRef = useRef();
    const flatListRef2 = useRef();
    const [message, setMessage] = useState(0)
    const [emojiContainerVisible, setEmojiContainerVisble] = useState(false)
    const [imageList, setImageList] = useState({});
    const [imageUploaded, setImageUploaded] = useState({});
    const userRefs = useRef([]); // Array to hold references to user objects
    const [typing, setTyping] = useState(false);
    // const [onlineUserIds, setOnlineUserIds] = useState([]);
    const [name, setName] = useState("")



    useEffect(() => {
        console.log(userHistory.users, "eusers");
        if (userHistory?.users?.length > 0) {
            userRefs.current = userHistory.users.map((user) => user); // Create references
        }
    }, [userHistory.users]);

    useEffect(() => {
        if (activeUser) {
            activeUserRef.current = activeUser
            setTyping(false);
        }
    }, [activeUser])

    const onEmojiClick = (event, emojiObject) => {

        setContent((prevContent) => prevContent + event?.emoji);
    };

    //    const handleOnChange=(event)=>{

    //     const searchQuery = event.target.value.toLowerCase();

    // //    alert(searchQuery.length)
    //    if(searchQuery.length <= 0){

    //     dispatch(getusersChat(""))
    //    }
    //       dispatch(getusersChat(searchQuery))
    //       console.log("working");

    //     }

    //search users 

    const handleOnChange = (event) => {
        const searchQuery = event.target.value.toLowerCase();
        setName(searchQuery); // Update the state to make the input controlled

        // Dispatch the search query or reset action based on input length
        if (searchQuery.trim().length > 0) {
            dispatch(getusersChat(searchQuery));
        } else {
            dispatch(getusersChat(""));
        }
    };





    //Add New Lead
    const openAddModal = () => {
        setOpenModal(true);
    };
    const closeAddModal = () => {
        setOpenModal(false);
    };
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };




    const getAllUserHistory = async () => {
        dispatch(getusersChat(""))
    }

    useEffect(() => {
        getAllUserHistory()
        dispatch(getAllActiveAdmins())
    }, [])





    useEffect(() => {
        if (socket) {
            socket.on('newMessage', (data) => {
                const newMessage = data;

                // Update chat history based on active user and incoming data
                updateChatHistory(newMessage);
            });

            socket.emit('message', () => {

            })


            return () => {
                socket.off('message');
            };
        }
    }, [socket]);



    // Update chat history based on new message data
    const updateChatHistory = (newMessage) => {
        const { senderId, message, createdAt } = newMessage;

        // Check if active user is the sender
        if (activeUserRef.current.userId === senderId?._id) {
            // dispatch(setMessages([...messages, newMessage])); 
            dispatch(addClientMessage(newMessage))
            socket.emit("message-read", { id: user._id, recipientId: senderId?._id }, (response) => {

                // This is the callback function that will handle the server's response
                if (response.success) {
                    console.log("Message marked as read successfully.");
                    // dispatch(getusersChat(""))
                } else {
                    console.error("Failed to mark message as read:", response.error);
                }
            });


            // return; 
        }

        // Check if sender exists in users list
        const foundUserIndex = userRefs.current.findIndex(
            (user) => {
                console.log(user, "user!.....")
                return user.userId === senderId._id
            }
        );


        if (foundUserIndex !== -1) {
            // Update user's last message and time in users state
            userRefs.current[foundUserIndex] = {
                ...userRefs.current[foundUserIndex],
                lastMessage: message,
                lastMessageTime: createdAt,
                read: activeUserRef.current.userId === senderId?._id ? true : false
            };

            dispatch(updateChatHistories({
                userId: senderId._id,
                lastMessage: message,
                lastMessageTime: createdAt,
                read: activeUserRef.current.userId === senderId?._id ? true : false
            }));
        } else {
            const newUser = {
                userId: senderId._id,
                userName: senderId.name || 'Super Admin', // Handle potential missing name
                profileImg: senderId.profileImg[0] || [],
                chatType: 'TEXT',
                lastMessage: message,
                lastMessageTime: createdAt,
                read: false

            };

            userRefs.current.push(newUser); // Add to ref
            dispatch(addNewChatHistory(newUser)); // Add new user to users state
        }

        // Update chats state (if needed, based kingster use case)

    };

    const sendMessageToServer = () => {
        if (!content.trim()) {
            // Don't send empty messages
            return;
        }

        const newMessage = {
            senderId: user._id, // The current user's ID
            senderType: "student",
            recipientType: "admin",
            recipientId: activeUser.userId, // The ID of the recipient
            message: content, // The message content
            // createdAt: new Date().toISOString(), // Timestamp of the message
            type: 'TEXT', // Type of message (TEXT, IMAGE, etc.)
        };
        console.log("emty string2");

        // // Emit the message to the server using WebSocket
        if (socket) {
            console.log("rmitting");

            socket.emit('createMessage', newMessage);
        }


        console.log(user._id, "euser idddd");

        const data = {
            senderId: {
                _id: user._id,
                name: user.name,
                profileImg: user.profileImg || [""]
            }, // The current user's ID
            senderType: "student",
            recipientType: "admin",
            recipientId: {
                _id: activeUser.userId,
                name: activeUser.userName,
                profileImage: activeUser.profileImage || ['']

            }, // The ID of the recipient
            message: content, // The message content
            // createdAt: new Date().toISOString(), // Timestamp of the message
            chatType: 'TEXT', // Type of message (TEXT, IMAGE, etc.)
        }

        console.log(data, "datai");


        // Optionally, update the Redux state optimistically
        dispatch(
            addClientMessage({
                ...data,
                createdAt: new Date().toISOString(), // Add timestamp to the message
            })
        );

        dispatch(updateChatHistories({
            userId: activeUser.userId,
            lastMessage: content,
            lastMessageTime: new Date().toISOString(),
            read: true
        }));
        // Clear the input field
        setContent('');
    };

    useEffect(() => {
        if (activeUser) {
            // reset the valuse
            // setChats([]);
            // setContent("")
            // setChatFetched(false);
            // setIsTyping(false);
            dispatch(getAllChats(activeUser?.userId))
            console.log("fetchingChats");
            setTyping(false);
            scrollToTop();
            scrollToTop2()

        }
    }, [activeUser])



    useEffect(() => {
        scrollToTop();
        scrollToTop2();
    }, [userHistory.messages, activeUser])


    console.log(activeUser, "activeuser");

    const scrollToTop = () => {
        if (flatListRef.current) {
            flatListRef.current.scrollTop = flatListRef.current.scrollHeight
        }
    };


    const scrollToTop2 = () => {
        if (flatListRef2.current) {
            flatListRef2.current.scrollTop = flatListRef2.current.scrollHeight
        }
    };

    //typing events


    // Emit typing event to server
    const handleTyping = () => {
        if (socket) {
            // setTyping(true);
            socket.emit("typing", {
                senderId: user._id,
                recipientId: activeUserRef.current?.userId,
                isTyping: true,
            });
        }
    };

    // Emit stop typing event when the user stops typing for a certain period (e.g., 1 second)
    useEffect(() => {
        const typingTimeout = setTimeout(() => {
            if (content === "") {
                setTyping(false);
                if (socket) {
                    socket.emit("typing", {
                        senderId: user._id,
                        recipientId: activeUserRef.current?.userId,
                        isTyping: false,
                    });
                }
            }
        }, 1000); // Set a delay before stopping the typing event    
        return () => clearTimeout(typingTimeout);
    }, [content]);


    // Listen for typing event from the server
    useEffect(() => {
        if (socket) {
            socket.on("typing", ({ senderId, isTyping }) => {
                console.log(senderId, user._id, "from typinng socket");

                if (senderId !== user._id && activeUserRef.current?.userId === senderId) {
                    setTyping(isTyping);
                } else {
                    setTyping(false)
                }
            });

            return () => {
                socket.off("typing");
            };
        }
    }, [socket, user._id]);



    //mark as read

    useEffect(() => {
        if (activeUser && socket) {
            socket.emit("message-read", { id: user._id, recipientId: activeUserRef.current.userId }, (response) => {
                // This is the callback function that will handle the server's response 
                console.log("emitting");

            });
            dispatch(
                updateReadStatus({
                    userId: activeUser.userId,
                    read: true,
                })
            );
        }
    }, [socket, activeUser, dispatch])

    // const 

    const [mobileViewChat, setMobileViewChat] = useState(false);
    const toggleFilterMobileView = () => {
        setMobileViewChat(!mobileViewChat)
    }


    return (
        <div className={messageStyle.mainContainerStyle}>
            {
                mobileViewChat && <div className={messageStyle.backArrowStyle} onClick={() => setMobileViewChat(false)} >
                    <div style={{ width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <BackArrowIcon />
                    </div>
                    Go back
                </div>
            }
            <div className={messageStyle.container}>
                <div className={messageStyle.notification}>
                    <div className={messageStyle.notifText}>
                        Message
                    </div>
                    <div className={messageStyle.composeStyle} onClick={() => openAddModal()}>
                        <PlusIcon /> <p>Compose</p>
                    </div>
                </div>
                <div className={messageStyle.search} style={{ marginTop: 10 }}>
                    <SearchIcon />
                    <input type="text" value={name} onChange={(e) => handleOnChange(e)} placeholder='Search' />
                </div>

                {/* // map userchat here */}



                {/* {userHistory.users?.map((item, key) => { */}
                {userHistory?.users?.map((item, key) => {
                    const isOnline = onlineUserIds.includes(item.userId); // Check if user is online
                    console.log(onlineUserIds, 'online users');

                    console.log(isOnline, "isOnline");

                    return (
                        <div
                            style={{ cursor: "pointer", background: item?._id === activeUser?._id ? "#D1DCFF" : "#fff", paddingTop: 12, paddingBottom: 12, }}
                            key={item._id}
                            onClick={() => {
                                dispatch(setActiveUser(item))
                                setMobileViewChat(!mobileViewChat)
                                // activeUserRef.current = item     //#D1DCFF
                            }}>
                            <div className={messageStyle.userProfileStyle}>
                                <div className={messageStyle.widthStyle}>
                                    <div style={{ position: "relative" }}>

                                        {isOnline && (
                                            <div style={{ position: "absolute", right: -2, top: 30 }}>
                                                <OnlineIcon /> {/* Show online icon if the user is online  */}
                                            </div>
                                        )}

                                        {
                                            item?.profileImg && item?.profileImg.length > 0
                                                ? <img src={item?.profileImg[0]}
                                                    style={{ width: 46, height: 46, borderRadius: 24, objectFit: "cover" }}
                                                    alt='Avatar'
                                                />
                                                : <img
                                                    src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1950300558.1723108329&semt=ais_hybrid"
                                                    alt="Default Profile"
                                                    style={{ width: 46, height: 46, borderRadius: 24, objectFit: "cover" }}
                                                />
                                        }
                                    </div>

                                    <div style={{ marginTop: 5 }}>
                                        <p className={messageStyle.nameText}>
                                            {item?.userName}

                                        </p>
                                        {/* {
                                            item.lastMessage?.lastMessage?.type === "IMAGE" ? <FontAwesomeIcon icon={faImage} className="dropdown-icon" /> :
                                                <span className={messageStyle.descText}>
                                                    {item?.lastMessage?.lastMessage?.content}
                                                </span>
                                        } */}
                                        <span className={messageStyle.descText}>
                                            {item?.lastMessage}
                                        </span>
                                    </div>
                                </div>
                                <div className={messageStyle.timeAndStatus}>
                                    <div className={messageStyle.descText} >
                                        {/* {item.lastMessageTime} */}
                                        {
                                            getRelativeTime(item.lastMessageTime)
                                        }
                                    </div>
                                    <div style={{ height: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                        {item?.read ? null : <UnreadMessage />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}


                {/* // it ends here */}


            </div>
            <div className={messageStyle.chatMobileContainer}>

                {
                    activeUser === null ? (
                        // Display "Select User" message
                        <div className={messageStyle.chatContainer} style={{ display: "flex", justifyContent: "center", gap: 50 }}>
                            <img
                                // src={activeUser?.profileImg[0]}
                                src={
                                    "https://kingster-dev-public.s3.ap-south-1.amazonaws.com/video/60317320260138291570.png"
                                }
                                alt="Profile"
                                style={{ width: "100%", height: "20%", objectFit: "contain", }}
                            />

                            <h4 style={{ fontSize: "1rem", textAlign: "center", color: "#7f8581" }}>Kingster chats 💬</h4>
                        </div>
                    ) : (

                        <div className={messageStyle.chatContainer}>
                            <div className={messageStyle.chatHeader}>
                                <div style={{ position: "relative" }}>
                                    <div style={{ position: "absolute", right: 8, top: 20 }}>
                                        {/* <OnlineIcon /> */}
                                        {console.log(activeUser, "active user ....")}

                                        {onlineUserIds.includes(activeUserRef?.current?.userId) && <OnlineIcon />} {/* Show OnlineIcon if user is online */}

                                    </div>
                                    <img
                                        // src={activeUser?.profileImg[0]}
                                        src={
                                            activeUser && activeUser.profileImg && activeUser.profileImg.length > 0
                                                ? activeUser.profileImg[0]
                                                : "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1950300558.1723108329&semt=ais_hybrid"
                                        }
                                        alt="Profile"
                                        className={messageStyle.profileImage}
                                    />
                                </div>
                                <div className={messageStyle.userInfo}>
                                    <span className={messageStyle.userName}>{activeUser.userName}</span>
                                    <span className={messageStyle.userStatus}>
                                        {onlineUserIds.includes(activeUserRef?.current?.userId) ? "Active Now" : "Offline"}
                                    </span>
                                </div>
                                <button className={messageStyle.optionsButton}><MoreIcons /></button>
                            </div>

                            <div ref={flatListRef} className={messageStyle.chatMessages}>
                                {userHistory?.messages.map((msg, index) => {
                                    const isSender = msg.senderId._id !== activeUser.userId;

                                    // Get the date of the current message in "day month year" format
                                    const currentMessageDate = new Date(msg.createdAt).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'long',
                                        year: 'numeric',
                                    });

                                    // Get the date of the previous message
                                    const previousMessageDate =
                                        index > 0
                                            ? new Date(userHistory.messages[index - 1].createdAt).toLocaleDateString(
                                                'en-GB',
                                                { day: '2-digit', month: 'long', year: 'numeric' }
                                            )
                                            : null;

                                    // Check if this message is the first one for a new day
                                    const isNewDay = currentMessageDate !== previousMessageDate;

                                    return (
                                        <div key={msg._id}>
                                            {/* Show the date if it's the start of a new day */}
                                            {isNewDay && (
                                                <div className={messageStyle.timeStampStyle}>
                                                    <p>{currentMessageDate}</p>
                                                </div>
                                            )}

                                            {/* Message Container */}
                                            <div
                                                className={
                                                    isSender
                                                        ? messageStyle.messageSentContainer
                                                        : messageStyle.messageReceivedContainer
                                                }
                                            >
                                                {/* Profile Image for Received Messages */}
                                                {!isSender && (
                                                    <div className={messageStyle.imageView}>
                                                        <img
                                                            src={
                                                                msg.senderId.profileImg[0] ||
                                                                'https://m.media-amazon.com/images/S/pv-target-images/ae4816cade1a5b7f29787d0b89610132c72c7747041481c6619b9cc3302c0101.jpg' // fallback image
                                                            }
                                                            alt="Sender Profile"
                                                            className={messageStyle.profileImage2}
                                                        />
                                                        <p>{formatDateToHHMM(msg.createdAt)}</p>
                                                    </div>
                                                )}

                                                {/* Message Content */}
                                                <div
                                                    className={
                                                        isSender
                                                            ? messageStyle.messageSent
                                                            : messageStyle.messageReceived
                                                    }
                                                >
                                                    <p>{msg.message}</p>
                                                    {isSender ? (
                                                        <p style={{ fontSize: "10px", lineHeight: "9px" }}>{formatDateToHHMM(msg.createdAt)}</p>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>


                            {/* Typing indicator */}
                            {typing && (


                                <div className={messageStyle.typingIndicator}>
                                    {/* <p className={messageStyle.typeText}> {`${activeUserRef.current.userName}  is   typing`}</p>  */}

                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            )}




                            <div className={messageStyle.messageInput}>
                                <div className={messageStyle.search}>
                                    <TypeMessageIcon />
                                    <input
                                        onChange={(e) => {
                                            setContent(e.target.value);
                                            handleTyping();
                                        }}
                                        value={content}
                                        type="text"
                                        placeholder="Type your message"
                                    />
                                </div>
                                <div onClick={() => sendMessageToServer()} className={messageStyle.sendButton}>Send <SentIcon /></div>
                            </div>
                        </div>
                    )}
            </div>

            {!mobileViewChat ? (
                <div className={messageStyle.mobileContainerUsers} >
                    <div className={messageStyle.notification}>
                        <div className={messageStyle.notifText}>
                            Message
                        </div>
                        <div className={messageStyle.composeStyle} onClick={() => openAddModal()}>
                            <PlusIcon /> <p>Compose</p>
                        </div>
                    </div>
                    <div className={messageStyle.search} style={{ marginTop: 10 }}>
                        <SearchIcon />
                        <input type="text" value={name} onChange={(e) => handleOnChange(e)} placeholder='Search' />
                    </div>



                    {/* // map userchat here */}



                    {/* {userHistory.users?.map((item, key) => { */}
                    {userHistory?.users?.map((item, key) => {
                        const isOnline = onlineUserIds.includes(item.userId); // Check if user is online
                        console.log(onlineUserIds, 'online users');

                        console.log(isOnline, "isOnline");

                        return (
                            <div
                                style={{ marginTop: 10, cursor: "pointer", background: item?._id === activeUser?._id ? "#D1DCFF" : "#fff", }}
                                key={item._id}
                                onClick={() => {
                                    dispatch(setActiveUser(item))
                                    setMobileViewChat(true);
                                    // activeUserRef.current = item     //#D1DCFF
                                }}>
                                <div className={messageStyle.userProfileStyle}>
                                    <div className={messageStyle.widthStyle}>
                                        <div style={{ position: "relative" }}>

                                            {isOnline && (
                                                <div style={{ position: "absolute", right: -2, top: 30 }}>
                                                    <OnlineIcon /> {/* Show online icon if the user is online */}
                                                </div>
                                            )}
                                            {/* <div style={{ position: "absolute", right: -2, top: 30 }}>

                                            <OnlineIcon />
                                        </div> */}
                                            {/* {
                                            item?.profileImg
                                                ? <img src={item?.profileImg[0]} style={{ width: 48, height: 48, borderRadius: 8, objectFit: "cover" }} />
                                                // : <div style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8, backgroundColor: (item?.userName).colorCode, color: "#fff", fontWeight: 500 }}>
                                                : <div style={{ width: 48, height: 48, display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 8, backgroundColor: "white", color: "#fff", fontWeight: 500 }}>
                                                    {/* {getLetterAndHex(item?.name).initials} */}
                                            {/* {item?.userName} */}
                                            {/* </div> */}
                                            {/* }  */}
                                            {
                                                item?.profileImg && item?.profileImg.length > 0
                                                    ? <img src={item?.profileImg[0]}
                                                        style={{ width: 46, height: 46, borderRadius: 24, objectFit: "cover" }}
                                                        alt='Avatar'
                                                    />
                                                    : <img
                                                        src="https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1950300558.1723108329&semt=ais_hybrid"
                                                        alt="Default Profile"
                                                        style={{ width: 46, height: 46, borderRadius: 24, objectFit: "cover" }}
                                                    />
                                            }
                                        </div>

                                        <div style={{ marginTop: 5 }}>
                                            <p className={messageStyle.nameText}>
                                                {item?.userName}

                                            </p>
                                            {/* {
                                            item.lastMessage?.lastMessage?.type === "IMAGE" ? <FontAwesomeIcon icon={faImage} className="dropdown-icon" /> :
                                                <span className={messageStyle.descText}>
                                                    {item?.lastMessage?.lastMessage?.content}
                                                </span>
                                        } */}
                                            <span className={messageStyle.descText}>
                                                {item?.lastMessage}
                                            </span>
                                        </div>
                                    </div>
                                    <div className={messageStyle.timeAndStatus}>
                                        <div className={messageStyle.descText} >
                                            {/* {item.lastMessageTime} */}
                                            {
                                                getRelativeTime(item.lastMessageTime)
                                            }
                                        </div>
                                        <div style={{ height: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                                            {item?.read ? null : <UnreadMessage />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}


                    {/* // it ends here */}


                </div>

            ) : (
                <div className={messageStyle.mobileContainer}>

                    {
                        activeUser === null ? (
                            // Display "Select User" message
                            <div className={messageStyle.chatContainer} style={{ display: "flex", justifyContent: "center", gap: 50 }}>
                                <img
                                    // src={activeUser?.profileImg[0]}
                                    src={
                                        "https://kingster-dev-public.s3.ap-south-1.amazonaws.com/video/60317320260138291570.png"
                                    }
                                    alt="Profile"
                                    style={{ width: "100%", height: "20%", objectFit: "contain", }}
                                />

                                <h4 style={{ fontSize: "1rem", textAlign: "center", color: "#7f8581" }}>Kingster chats 💬</h4>
                            </div>
                        ) : (

                            <div className={messageStyle.chatContainer}>
                                <div className={messageStyle.chatHeader}>
                                    <div style={{ position: "relative" }}>
                                        <div style={{ position: "absolute", right: 8, top: 20 }}>
                                            {/* <OnlineIcon /> */}
                                            {console.log(activeUser, "active user ....")}

                                            {onlineUserIds.includes(activeUserRef?.current?.userId) && <OnlineIcon />} {/* Show OnlineIcon if user is online */}

                                        </div>
                                        <img
                                            // src={activeUser?.profileImg[0]}
                                            src={
                                                activeUser && activeUser.profileImg && activeUser.profileImg.length > 0
                                                    ? activeUser.profileImg[0]
                                                    : "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?ga=GA1.1.1950300558.1723108329&semt=ais_hybrid"
                                            }
                                            alt="Profile"
                                            className={messageStyle.profileImage}
                                        />
                                    </div>
                                    <div className={messageStyle.userInfo}>
                                        <span className={messageStyle.userName}>{activeUser.userName}</span>
                                        <span className={messageStyle.userStatus}>
                                            {onlineUserIds.includes(activeUserRef?.current?.userId) ? "Active Now" : "Offline"}
                                        </span>
                                    </div>
                                    <button className={messageStyle.optionsButton}><MoreIcons /></button>
                                </div>

                                <div ref={flatListRef2} className={messageStyle.chatMessages}>
                                    {userHistory?.messages.map((msg, index) => {
                                        const isSender = msg.senderId._id !== activeUser.userId;

                                        // Get the date of the current message in "day month year" format
                                        const currentMessageDate = new Date(msg.createdAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric',
                                        });

                                        // Get the date of the previous message
                                        const previousMessageDate =
                                            index > 0
                                                ? new Date(userHistory.messages[index - 1].createdAt).toLocaleDateString(
                                                    'en-GB',
                                                    { day: '2-digit', month: 'long', year: 'numeric' }
                                                )
                                                : null;

                                        // Check if this message is the first one for a new day
                                        const isNewDay = currentMessageDate !== previousMessageDate;

                                        return (
                                            <div key={msg._id}>
                                                {/* Show the date if it's the start of a new day */}
                                                {isNewDay && (
                                                    <div className={messageStyle.timeStampStyle}>
                                                        <p>{currentMessageDate}</p>
                                                    </div>
                                                )}

                                                {/* Message Container */}
                                                <div
                                                    className={
                                                        isSender
                                                            ? messageStyle.messageSentContainer
                                                            : messageStyle.messageReceivedContainer
                                                    }
                                                >
                                                    {/* Profile Image for Received Messages */}
                                                    {!isSender && (
                                                        <div className={messageStyle.imageView}>
                                                            <img
                                                                src={
                                                                    msg.senderId.profileImg[0] ||
                                                                    'https://m.media-amazon.com/images/S/pv-target-images/ae4816cade1a5b7f29787d0b89610132c72c7747041481c6619b9cc3302c0101.jpg' // fallback image
                                                                }
                                                                alt="Sender Profile"
                                                                className={messageStyle.profileImage2}
                                                            />
                                                            <p>{formatDateToHHMM(msg.createdAt)}</p>
                                                        </div>
                                                    )}

                                                    {/* Message Content */}
                                                    <div
                                                        className={
                                                            isSender
                                                                ? messageStyle.messageSent
                                                                : messageStyle.messageReceived
                                                        }
                                                    >
                                                        <p>{msg.message}</p>
                                                        {isSender ? (
                                                            <p style={{ font: 10 }}>{formatDateToHHMM(msg.createdAt)}</p>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>


                                {/* Typing indicator */}
                                {typing && (


                                    <div className={messageStyle.typingIndicator}>
                                        {/* <p className={messageStyle.typeText}> {`${activeUserRef.current.userName}  is   typing`}</p>  */}

                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                )}




                                <div className={messageStyle.messageInput}>
                                    <div className={messageStyle.search}>
                                        <TypeMessageIcon />
                                        <input
                                            onChange={(e) => {
                                                setContent(e.target.value);
                                                handleTyping();
                                            }}
                                            value={content}
                                            type="text"
                                            placeholder="Type your message"
                                        />
                                    </div>
                                    <div onClick={() => sendMessageToServer()} className={messageStyle.sendButton}>Send <SentIcon /></div>
                                </div>
                            </div>
                        )}
                </div>
            )}
            <NewMessageModal
                open={openModal}
                closeModal={closeAddModal}
            />
        </div>
    )
}



export default Messages